<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/daily/schedule/index' }">日程</el-breadcrumb-item>
      <el-breadcrumb-item>{{ form.id <= 0 ? '添加' : '编辑'}}日程</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="160px">
          <el-form-item label="内容" prop="content">
            <el-col :span="12">
              <el-input type="textarea" v-model="form.content" placeholder="请输入内容"></el-input>
            </el-col>
          </el-form-item>
          
          <el-form-item label="起始时间" prop="start_time">
            <el-col :span="12">
              <el-time-select
                placeholder="起始时间"
                v-model="form.start_time"
                :picker-options="{
                  start: '06:00',
                  step: '00:05',
                }">
              </el-time-select>
            </el-col>
          </el-form-item>

          <el-form-item label="结束时间" prop="end_time">
            <el-col :span="12">
              <el-time-select
                placeholder="结束时间"
                v-model="form.end_time"
                :picker-options="{
                  start: '06:00',
                  step: '00:05',
                  minTime: form.start_time
                }">
              </el-time-select>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        id: '',
        content: '',
        start_time: '06:00',
        end_time: '06:00'
      },
      rules: {
        content: [
          {  required: true, message: '请输入内容', trigger: 'blur' },
          { min: 1, max: 255, message: '内容长度在1到255个字符', trigger: 'blur' }
        ],
        start_time: [
          { required: true, message: '请选择开始时间', trigger: 'blur' },
        ],
        end_time: [
          { required: true, message: '请选择开始时间', trigger: 'blur' },
        ],
      }
    };
  },
  methods: {
    loadSchedule() {
      var id = this.$route.query ? this.$route.query.id : 0;
      
      if(!id) {
        return 0
      }

      this.$ajax({
        url: "/daily/schedule/one?id=" + id,
        type:"GET",
      }).then(res => {
        this.form = {
          id: res.data.id,
          content: res.data.content,
          start_time: res.data.start_time,
          end_time: res.data.end_time,
        }
      });
    },
    save() {
      let form = this.form;
      this.$refs.ruleForm.validate((valid) => {
        if(!valid) {
          return false;
        }

        // 开始处理loading.
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          type: 'POST',
          url: '/daily/schedule/save',
          data: form,
        }).then((res) => {
          loading.close()
          if(res.code != 200) {
            return this.$util.msg(res.msg, "error");
          }
          
          this.$util.msg(res.msg, "success");

          setTimeout(() => {
            this.$router.push({ path: "/daily/schedule/index" });
          });
        })
      });

      return false;
    }
  },
  mounted() {
    this.loadSchedule()
  }
};
</script>
<style>
</style>